var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremiumIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.695312 3.84296L4.92245 0.902344L9.1496 3.84296V9.35663H0.695312V3.84296Z",
    fill: "#FEB517"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62795 8.29579L4.98579 7.25829L3.34896 8.29579L3.78083 6.33294L2.33594 5.02064L4.24468 4.84678L4.98579 2.99609L5.72689 4.84117L7.63564 5.01503L6.19075 6.33294L6.62795 8.29579Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumIcon);
export default __webpack_public_path__ + "static/media/premium-icon.546c53fa6084337c5529e281f42c063c.svg";
export { ForwardRef as ReactComponent };